export default "__VITE_ASSET__BdGufeMm__"